export const FETCH_ENV_REQUEST = 'FETCH_ENV_REQUEST';
export const FETCH_ENV_SUCCESS = 'FETCH_ENV_SUCCESS';
export const FETCH_ENV_FAILURE = 'FETCH_ENV_FAILURE';